import { FormattedMessage } from 'react-intl';

import { Tabs, Tab, TabList } from '~/components/ui/tabs';

interface DownloadFullReportDialogHeaderProps {
  selectedTab: number;
  setTab: (newValue: number) => void;
}

const DownloadFullReportDialogHeader = ({
  selectedTab,
  setTab,
}: DownloadFullReportDialogHeaderProps) => {
  const handleTabChange = (
    _: React.SyntheticEvent | null,
    newValue: number | string | null,
  ) => {
    if (newValue === null) return;
    if (typeof newValue === 'string') return;
    setTab(newValue);
  };

  return (
    <div className='flex flex-row mt-16 border-b border-gray-200'>
      <div className='basis-96'>
        <h5 className='text-2xl ml-9 mr-20 mb-2'>
          <FormattedMessage defaultMessage='Download Case Report' />
        </h5>
      </div>
      <Tabs
        value={selectedTab}
        onChange={(event, value) => handleTabChange(event, value)}
        orientation='horizontal'
      >
        <TabList>
          <Tab variant='soft'>
            <FormattedMessage defaultMessage='Build Report' />
          </Tab>
          <Tab variant='soft'>
            <FormattedMessage defaultMessage='Preview Report' />
          </Tab>
        </TabList>
      </Tabs>
    </div>
  );
};

export default DownloadFullReportDialogHeader;
